// @flow
import type { BusinessLocationRecord } from "redux/modules/createCabelasClass/records/BusinessLocationRecord";

type LocationResource = {
  id: string,
  attributes: {
    businessId: string,
    chapterId?: ?string,
    name: string,
    address: $PropertyType<BusinessLocationRecord, "address">,
    lat: string,
    lng: string,
    instructors: Array<{ userId: string }>,
  },
};

export type InstructorLocationsResponse = {
  data: Array<LocationResource>,
  meta: { totalPages: number },
};

export const parseInstructorLocations = (
  json: InstructorLocationsResponse,
  businessId?: string
): Array<BusinessLocationRecord> => {
  if (
    !Array.isArray(json?.data) ||
    !Number.isInteger(json.meta?.totalPages) ||
    json.meta.totalPages < 0
  ) {
    throw new Error("Invalid assigned locations response. Reload locations.");
  }

  return json.data.map(
    ({ id, attributes }: LocationResource): BusinessLocationRecord => {
      if (
        typeof id !== "string" ||
        !id.trim() ||
        typeof attributes?.businessId !== "string" ||
        !attributes.businessId.trim() ||
        (businessId !== undefined && attributes.businessId !== businessId) ||
        !Array.isArray(attributes.instructors)
      ) {
        throw new Error("Invalid assigned location. Reload locations.");
      }

      const hostIds = [
        ...new Set(
          attributes.instructors.map(
            ({ userId }: { userId: string }): string => userId
          )
        ),
      ];
      if (!hostIds.length || hostIds.some((id: string): boolean => !id)) {
        throw new Error(
          "The assigned location has no valid instructors. Reload locations."
        );
      }

      return { ...attributes, objectID: id, locationId: id, hostIds };
    }
  );
};

export const isChapterLocation = (location: BusinessLocationRecord): boolean =>
  typeof location.chapterId === "string" && !!location.chapterId.trim();
